import React from "react";
import BottomSheet from "src/components/app/BottomSheet";

type Props = {
  show: boolean;
  onClose: () => void;
};

const CGMGuideBottomSheet: React.FC<Props> = ({ show, onClose }) => {
  return (
    <BottomSheet show={show} handleClose={onClose} zIndex={70} showCloseButton>
      <div className="px-6 pt-5 pb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          What is Continuous Glucose Monitoring?
        </h2>
        <p className="text-sm text-gray-600 leading-6">
          Continuous Glucose Monitoring (CGM) measures your glucose levels
          throughout the day and night. Unlike fingerstick measurements that
          provide single snapshots, CGM provides a continuous stream of data.
        </p>

        <div className="mt-6">
          <h3 className="text-base font-semibold text-gray-900 mb-2">
            Why use a CGM?
          </h3>
          <ul className="space-y-2 text-sm text-gray-700 leading-6 list-disc pl-5">
            <li>Know how your body responds to food, stress, and sleep.</li>
            <li>Spot patterns that spike or crash your glucose.</li>
            <li>Stay in range and make better day-to-day choices.</li>
            <li>Get reliable insights from clinically validated tracking.</li>
          </ul>
        </div>

        <div className="mt-6">
          <h3 className="text-base font-semibold text-gray-900 mb-2">
            Frequently asked questions
          </h3>
          <div className="space-y-3">
            <div className="border border-gray-200 rounded-xl p-4 bg-white">
              <p className="font-semibold text-gray-900 text-sm mb-1">
                Why can CGM differ from a glucometer?
              </p>
              <p className="text-sm text-gray-600 leading-6">
                CGM reads glucose in interstitial fluid, so values can lag
                behind blood glucose—especially after meals.
              </p>
            </div>
            <div className="border border-gray-200 rounded-xl p-4 bg-white">
              <p className="font-semibold text-gray-900 text-sm mb-1">
                Why is warmup needed?
              </p>
              <p className="text-sm text-gray-600 leading-6">
                After sensor insertion, your body needs time to stabilize around
                the sensor for reliable readings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CGMGuideBottomSheet;

